/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Workout_Add_FullInputs */

const en_us2_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This workout already took ${i?.max} extra exercises.`)
};

const pt_br2_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este treino já recebeu ${i?.max} exercícios a mais.`)
};

const es_419_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este entrenamiento ya recibió ${i?.max} ejercicios extra.`)
};

const pt_pt2_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Este treino já recebeu ${i?.max} exercícios a mais.`)
};

const fr_fr2_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette séance a déjà reçu ${i?.max} exercices en plus.`)
};

const de_de2_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Training hat schon ${i?.max} zusätzliche Übungen.`)
};

const it_it2_workout_add_full = /** @type {(inputs: Workout_Add_FullInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo allenamento ha già ricevuto ${i?.max} esercizi extra.`)
};

/**
* | output |
* | --- |
* | "This workout already took {max} extra exercises." |
*
* @param {Workout_Add_FullInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_add_full = /** @type {((inputs: Workout_Add_FullInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Add_FullInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_add_full(inputs)
	if (locale === "es-419") return es_419_workout_add_full(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_add_full(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_add_full(inputs)
	if (locale === "de-DE") return de_de2_workout_add_full(inputs)
	if (locale === "it-IT") return it_it2_workout_add_full(inputs)
	return en_us2_workout_add_full(inputs)
});
export { workout_add_full as "workout.add_full" }